const route = (entry, resolve) => ({
  template: "<" + entry + "></" + entry + ">",
  resolve: {
    async: [
      "$q",
      function ($q) {
        const defer = $q.defer();

        resolve(defer.resolve);
        return defer.promise;
      },
    ],
  },
});

const rootRouteTemplate = `<lba-route-root target="vm.target"></lba-route-root>`;
const redirectTemplate = `<lba-redirect></lba-redirect>`;

function injectTarget(target) {
  return target;
}

function rootRouteController(target) {
  const vm = this;
  vm.target = target;
}

export default (app) => {
  const $inject = ["$routeProvider"];

  const RouterConfig = function ($routeProvider) {
    $routeProvider

      .when("/", { redirectTo: "/debtors" })

      .when(
        "/login",
        route("lb-authenticate", (callback) =>
          require.ensure([], () =>
            callback(app.register(require("../components/lbaAuth0Authenticate/lbAuthenticate").name))
          )
        )
      )
      .when(
        "/access-denied",
        route("lb-access-denied", (callback) =>
          require.ensure([], () =>
            callback(app.register(require("../components/lbaAuth0Authenticate/lbAccessDenied").name))
          )
        )
      )
      .when(
        "/logout",
        route("lb-logout", (callback) =>
          require.ensure([], () =>
            callback(app.register(require("../components/lbaAuth0Authenticate/lbLogout").name))
          )
        )
      )
      .when(
        "/loginForm",
        route("lba-login", (callback) =>
          require.ensure([], () =>
            callback(app.register(require("../components/lbaLogin").name))
          )
        )
      )
      .when(
        "/noaccess",
        route("lba-login", (callback) =>
          require.ensure([], () =>
            callback(app.register(require("../components/lbaLogin").name))
          )
        )
      )

      /**
       *************************** DEBTORS START ***************************
       */

      .when("/debtors", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorList");
            },
          ],
        },
      })

      .when("/debtors/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorAddResource");
            },
          ],
        },
      })

      .when("/debtors/:debtorId", { redirectTo: "/debtors/:debtorId/info" })

      .when("/debtors/:debtorId/:tab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("Debtor");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/:tab/debtor-order-number-codes", {
        redirectTo: "/debtors/:debtorId/:tab/debtor-order-number-codes/0",
      })

      .when(
        "/debtors/:debtorId/:tab/debtor-order-number-codes/:debtorOrderNumberCodesIndex",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("DebtorOrderNumberCodesItem");
              },
            ],
          },
        }
      )

      .when("/debtors/:debtorId/:tab/terms-and-conditions", {
        redirectTo: "/debtors/:debtorId/:tab/terms-and-conditions/0",
      })

      .when("/debtors/:debtorId/:tab/terms-and-conditions/:debtorTermsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("TermsAndConditionsItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/:tab/itinerary-policies/", {
        redirectTo: "/debtors/:debtorId/:tab/itinerary-policies/0/general",
      })

      .when("/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex", {
        redirectTo:
          "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general",
      })

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/:itineraryPoliciesTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/items/:ItinPolItemIndex",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesItemsItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/profile-attributes/:ItinPolProfileAttributesItemIndex",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesProfileAttributesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/general/profile-attributes/:ItinPolProfileAttributesItemIndex/conditions/:EnhancedPolicyRulesConditionsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPolicyEnhancedPolicyRulesConditionsItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/benchmark-policies/:flightBenchPolItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesFlightBenchmarksPoliciesItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/benchmark-exceptions/:flightBenchExcItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesFlightBenchmarksExceptionsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policies/:flightPolItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesFlightPoliciesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policy-exceptions/:flightPolExcItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesFlightPolicyExceptionsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/lead-time-for-in-policy-booking-exceptions/:flightLessThanXPolItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesLessThanXDayExceptionsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/fly-america-policy-exceptions/:flyAmericaPolicyExceptionItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesFlightFlyAmericaPolicyExceptionsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/flight/policy-exception-settings/:flightPolExcSetItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesFlightPolicyExceptionSettingsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/rail/policies/:railPolItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesRailPoliciesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/rail/policy-exceptions/:railPolExcItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesRailPolicyExceptionsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/policies/:hotelPolItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesHotelPoliciesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/hotel-rate-categories/:hotelRCItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesHotelRateCategoriesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/exclude-aggregator-rates-by-chain/:hotelEACItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesHotelExcludedAggregatorChainsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel/no-hotel-policy/:hotelNHPItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesHotelNoHotelPoliciesItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel-lost-savings/policy-exceptions/:hotelPolExcItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesHotelPolicyExceptionsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/hotel-lost-savings/policy-exception-settings/:ItinPolExcSetItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesHotelPolicyExceptionSettingsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/car-policies/:carPolItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesCarPoliciesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-exceptions/:carPolExcItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesCarPolicyExceptionsItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-exception-settings/:carPolExcSetItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesCarPolicyExceptionSettingsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-preferred/:carPolPrefItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ItineraryPoliciesCarPolicyPreferredItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/:tab/itinerary-policies/:ItinPolIndex/car/policy-restriction/:carPolRestrictedItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "ItineraryPoliciesCarPolicyRestrictionItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/company-references/company-references/:compRefItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CompanyReferencesGridItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/company-references/company-references/:compRefItem/children/:compRefChildItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CompanyReferencesChildrenItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/company-references/company-references/:compRefItem/employee-codes/:compRefItemItemIndex",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CompanyReferencesItemsItem");
              },
            ],
          },
        }
      )

      .when("/debtors/:debtorId/agency/agency-credit-cards/:debtAgCCItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AgencyCreditCardsItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/agency/agency-reason-codes/:debAgReCoItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorAgencyReasonCodesItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/agency/virtual-credit-card-configuration/:virtualCCConfig", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorAgencyVirtualCreditCardConfigurationsItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/agency/virtual-credit-card-configuration/:virtualCCConfig/company-reference-mappings/:companyReferenceItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorAgencyVirtualCreditCardConfigurationsCompanyReferenceMappingItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/agency/payment-configurations/:payConItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PaymentConfigurationsItem");
            },
          ],
        },
      })

      .when(
        "/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("PaymentTypesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem/configurations/:payTypeConItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("PaymentTypesConfigurationsItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/agency/payment-configurations/:payConItem/payment-types/:payConPayTypItem/configurations/:payTypeConItem/suppliers/:payConSupItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "PaymentConfigurationsPaymentTypesConfigurationsSuppliersItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/flight-sectors/one-way-fare-rules/:oneWayFarRuItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("OneWayFareRulesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/flight-sectors/flight-search-windows/:flightSearchWindowItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("FlightSearchWindowItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/flight-sectors/combinable-fare-rules/:combFareRulesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CombinableFareRulesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/flight-sectors/flight-corporate-rate-codes/:flightCorporateRateCodeItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("FlightCorporateRateCodeItem");
              },
            ],
          },
        }
      )
      .when("/debtors/:debtorId/flight-sectors/flight-modification-settings/:iiflightModificationSettingItem",{
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorFlightModificationSettingItem");
            },
          ],
        },
      })
      .when("/debtors/:debtorId/flight-sectors/custom-airport-hubs/:idebtorCustomAirportHubsItem",{
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorCustomAirportHubsItem");
            },
          ],
        },
      })
      .when("/debtors/:debtorId/flight-sectors/flight-search-configuration/:iflightSearchConfigurationItem",{
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorFlightSearchConfigurationItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/flight-limit-passenger-policy/udid-configurations/:udidConfigItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("LimitPassengerPolicyUdidItem");
              },
            ],
          },
        }
      )

      .when("/debtors/:debtorId/hotel-sectors/cities/:hotConRadCitiesItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelConfigurationRadiusCitiesItem");
            },
          ],
        },
      })

      .when(
        "/debtors/:debtorId/hotel-sectors/hotel-payment-narratives/:hotConPaymentNarrativesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("HotelConfigurationPaymentNarrativesItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/hotel-sectors/hotel-amenity-filters/:hotConHotelAmenityFiltersItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("HotelConfigurationHotelAmenityFiltersItem");
              },
            ],
          },
        }
      )

      .when("/debtors/:debtorId/gds/gds/:GdsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorGdsItem");
            },
          ],
        },
      })

      .when("/debtors/:debtorId/gds/gds/:GdsItem/mi-questions/:MiItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("DebtorGdsMiQuestionsItem");
            },
          ],
        },
      })

      .when(
        "/debtors/:debtorId/gds/gds/:GdsItem/mi-questions/:MiItem/questions/:question",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("DebtorGdsMiQuestionsItemQuestionsItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/gds/gds/:GdsItem/corporate-identifiers/:corpId",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("DebtorGdsCorporateIdentifiersItem");
              },
            ],
          },
        }
      )

      .when(
        "/debtors/:debtorId/gds/gds/:GdsItem/passive-flight-segment-remarks/:RemarkTemplate",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "DebtorGdsPassiveFlightSegmentRemarkTemplate"
                );
              },
            ],
          },
        }
      )

      .when("/debtors/:debtorId/:tab/company-reference-mappings", {
        redirectTo: "/debtors/:debtorId/:tab/company-reference-mappings/0",
      })

      .when(
        "/debtors/:debtorId/:tab/company-reference-mappings/:companyReferenceItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("GroundTransportationCompanyReferenceMappingItem");
              },
            ],
          },
        }
      )

      .when("/debtors/:debtorId/:tab/rail-supplier-settings", {
        redirectTo: "/debtors/:debtorId/:tab/rail-supplier-settings/0",
      })

      .when(
        "/debtors/:debtorId/:tab/rail-supplier-settings/:railSuppSettingItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("RailSupplierSettingsItem");
              },
            ],
          },
        }
      )

      /**
       *************************** DEBTORS END ***************************
       */

      /**
       *************************** SETTINGS START ***************************
       */

      .when("/settings", { redirectTo: "/settings/settings-misc" })

      .when("/settings/:tab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SettingsResource");
            },
          ],
        },
      })

      .when("/settings/settings-misc/error-messages/:ErMesItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ErrorMessagesItem");
            },
          ],
        },
      })

      .when("/settings/settings-misc/terms-and-condition/:termsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("TermsAndConditionsSettingsItem");
            },
          ],
        },
      })

      .when("/settings/settings-misc/vehicle-defaults/:vehicleDefaultItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("VehicleDefaultsItem");
            },
          ],
        },
      })

      .when("/settings/settings-misc/vehicle-emissions/:vehicleEmissionItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("VehicleEmissionsItem");
            },
          ],
        },
      })

      .when("/settings/settings-misc/flight-fare-data/:flFareDataItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("FlightFareDataItem");
            },
          ],
        },
      })

      .when(
        "/settings/settings-misc/flight-fare-bucket-data/:ffbcFlightFareBucketClassesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("FlightFareBucketClassesItem");
              },
            ],
          },
        }
      )

      .when(
        "/settings/guest-travellers-titles/guest-travellers-titles/:gusTravTitleItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("GuestTravellersTitlesGridItem");
              },
            ],
          },
        }
      )

      .when("/settings/gds/gds/:GdsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("GdssettingsItem");
            },
          ],
        },
      })

      .when(
        "/settings/gds/gds/:GdsItem/passive-flight-segment-remarks/:RemarkTemplate",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("GdsPassiveFlightSegmentRemarkTemplate");
              },
            ],
          },
        }
      )

      .when(
        "/settings/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CountryPnrFinishingRemarksGridItem");
              },
            ],
          },
        }
      )

      .when(
        "/settings/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem/gds-remarks/:GdsRemarksItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CountryPnrFinishingRemarksGdsRemarksItem");
              },
            ],
          },
        }
      )

      .when("/settings/sales-agents/sales-agents/:salSalesAgentsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SalesAgentsItem");
            },
          ],
        },
      })

      .when(
        "/settings/per-diem/per-diem-default-rates/:pdPerDiemDefaultRatesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("PerDiemDefaultRatesItem");
              },
            ],
          },
        }
      )

      .when("/settings/per-diem/per-diem-mappings/:pdPerDiemMappingsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PerDiemMappingsItem");
            },
          ],
        },
      })

      .when("/settings/hotel/hotel-rate-categories/:hrcHotelRateCategoriesItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelRateCategoriesItem");
            },
          ],
        },
      })

      .when("/settings/hotel/hotel-amenity-filters/:hafHotelAmenityFiltersItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelAmenityFiltersItem");
            },
          ],
        },
      })

      .when("/settings/rail/character-mappings/:rcmRailCharacterMappingsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailCharacterMappingsItem");
            },
          ],
        },
      })
      .when("/settings/named-lists/named-lists/:iinamedListItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("NamedListItem");
            },
          ],
        },
      })
      .when("/settings/country-airlines/country-airlines/:iicountryAirlineListItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CountryAirlinesItem");
            },
          ],
        },
      })
      .when("/settings/flight/flight-modification-settings/:iiflightModificationSettingItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("FlightModificationSettingItem");
            },
          ],
        },
      })
      .when("/settings/flight/custom-airport-hubs/:isettingsCustomAirportHubsItem",{
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SettingsCustomAirportHubsItem");
            },
          ],
        },
      })
      .when("/settings/flight/flight-search-configuration/:iflightSearchConfigurationItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("FlightSearchConfigurationItem");
            },
          ],
        },
      })
        .when("/settings/flight/flight-ancillary-codes/:iflightAncillaryCodesItem", {
            template: rootRouteTemplate,
            controller: ["targetName", rootRouteController],
            controllerAs: "vm",
            resolve: {
                targetName: [
                    () => {
                        return injectTarget("FlightAncillaryCodesItem");
                    },
                ],
            },
        })
      
      .when("/settings/credit-card-mappings/credit-card-mappings/:ccCreditCardMappingsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CreditCardMappingsItem");
            },
          ],
        },
      })

      /**
       *************************** SETTINGS END ***************************
       */

      /**
       *************************** GLOBAL SETTINGS START ***************************
       */

      .when("/global-settings", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget('GlobalSettingsList');
            },
          ],
        },
      })

      .when("/global-settings/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("GlobalSettingsAddResource");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId", { redirectTo: "/global-settings/:settingsId/settings-misc" })

      .when("/global-settings/:settingsId/:tab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("GlobalSettingsResource");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/settings-misc/error-messages/:ErMesItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ErrorMessagesItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/settings-misc/terms-and-condition/:termsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("TermsAndConditionsSettingsItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/settings-misc/vehicle-defaults/:vehicleDefaultItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("VehicleDefaultsItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/settings-misc/vehicle-emissions/:vehicleEmissionItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("VehicleEmissionsItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/settings-misc/flight-fare-data/:flFareDataItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("FlightFareDataItem");
            },
          ],
        },
      })

      .when(
        "/global-settings/:settingsId/settings-misc/flight-fare-bucket-data/:ffbcFlightFareBucketClassesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("FlightFareBucketClassesItem");
              },
            ],
          },
        }
      )

      .when(
        "/global-settings/:settingsId/guest-travellers-titles/guest-travellers-titles/:gusTravTitleItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("GuestTravellersTitlesGridItem");
              },
            ],
          },
        }
      )

      .when("/global-settings/:settingsId/gds/gds/:GdsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("GdssettingsItem");
            },
          ],
        },
      })

      .when(
        "/global-settings/:settingsId/gds/gds/:GdsItem/passive-flight-segment-remarks/:RemarkTemplate",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("GdsPassiveFlightSegmentRemarkTemplate");
              },
            ],
          },
        }
      )

      .when(
        "/global-settings/:settingsId/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CountryPnrFinishingRemarksGridItem");
              },
            ],
          },
        }
      )

      .when(
        "/global-settings/:settingsId/country-pnr-remarks/country-pnr-remarks/:CntPnrFinRemItem/gds-remarks/:GdsRemarksItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CountryPnrFinishingRemarksGdsRemarksItem");
              },
            ],
          },
        }
      )

      .when("/global-settings/:settingsId/sales-agents/sales-agents/:salSalesAgentsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SalesAgentsItem");
            },
          ],
        },
      })

      .when(
        "/global-settings/:settingsId/per-diem/per-diem-default-rates/:pdPerDiemDefaultRatesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("PerDiemDefaultRatesItem");
              },
            ],
          },
        }
      )

      .when("/global-settings/:settingsId/per-diem/per-diem-mappings/:pdPerDiemMappingsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PerDiemMappingsItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/hotel/hotel-rate-categories/:hrcHotelRateCategoriesItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelRateCategoriesItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/hotel/hotel-amenity-filters/:hafHotelAmenityFiltersItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelAmenityFiltersItem");
            },
          ],
        },
      })

      .when("/global-settings/:settingsId/rail/character-mappings/:rcmRailCharacterMappingsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailCharacterMappingsItem");
            },
          ],
        },
      })
      .when("/global-settings/:settingsId/named-lists/named-lists/:iinamedListItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("NamedListItem");
            },
          ],
        },
      })
      .when("/global-settings/:settingsId/country-airlines/country-airlines/:iicountryAirlineListItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CountryAirlinesItem");
            },
          ],
        },
      })
      .when("/global-settings/:settingsId/flight/flight-modification-settings/:iiflightModificationSettingItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("FlightModificationSettingItem");
            },
          ],
        },
      })
      .when("/global-settings/:settingsId/flight/custom-airport-hubs/:isettingsCustomAirportHubsItem",{
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SettingsCustomAirportHubsItem");
            },
          ],
        },
      })
      .when("/global-settings/:settingsId/flight/flight-search-configuration/:iflightSearchConfigurationItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("FlightSearchConfigurationItem");
            },
          ],
        },
      })
    .when("/global-settings/:settingsId/flight/flight-ancillary-codes/:iflightAncillaryCodesItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
            targetName: [
                () => {
                    return injectTarget("FlightAncillaryCodesItem");
                },
            ],
        },
    })
      
      .when("/global-settings/:settingsId/credit-card-mappings/credit-card-mappings/:ccCreditCardMappingsItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CreditCardMappingsItem");
            },
          ],
        },
      })

      /**
       *************************** GLOBAL SETTINGS END ***************************
       */

      /**
       *************************** CREDIT CARD START ***************************
       */

      .when("/credit-cards", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CreditCardsList");
            },
          ],
        },
      })

      .when("/credit-cards/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CreditCardsAddResource");
            },
          ],
        },
      })

      .when("/credit-cards/:ccId", { redirectTo: "/credit-cards/:ccId/info" })

      .when("/credit-cards/:ccId/:ccTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CreditCardsResource");
            },
          ],
        },
      })

      /**
       *************************** CREDIT CARD END ***************************
       */

      /**
       *************************** Airline Carriers START ***************************
       */

      .when("/airline-carriers", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirlineCarriersList");
            },
          ],
        },
      })

      .when("/airline-carriers/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirlineCarriersAddResource");
            },
          ],
        },
      })

      .when("/airline-carriers/:airCarriersId", {
        redirectTo: "/airline-carriers/:airCarriersId/info",
      })

      .when("/airline-carriers/:airCarriersId/:airCarriersTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirlineCarriersResource");
            },
          ],
        },
      })

      .when(
        "/airline-carriers/:airCarriersId/info/country-data/:AirCountryDataItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("AirlineCarrierCountryDataGridItem");
              },
            ],
          },
        }
      )

      .when("/airline-carriers/:airCarriersId/info/brands/:BrandItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirlineCarrierBrandsBrandItem");
            },
          ],
        },
      })

      .when(
        "/airline-carriers/:airCarriersId/info/fare-classes/:AirCarrierFaClassItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("AirlineCarrierFareClassesGridItem");
              },
            ],
          },
        }
      )

      .when(
        "/airline-carriers/:airCarriersId/info/fare-classes/:AirCarrierFaClassItem/country-fare-class/:AirFareClsCuFareClsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "AirlineCarrierFareClassesCountryFareClassItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("AirlineCarrierFareGdsSettingsItem");
              },
            ],
          },
        }
      )

      .when(
        "/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/fares/:airGdsFareItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("AirlineCarrierFareGdsSettingsFaresItem");
              },
            ],
          },
        }
      )

      .when(
        "/airline-carriers/:airCarriersId/info/gds-fare-settings/:AirFareGdsSetItem/fares/:airGdsFareItem/gds-fare-settings/:airCarrierGDSFarSetItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "AirlineCarrierFareGdsSettingsFaresItemFareDataItem"
                );
              },
            ],
          },
        }
      )

      .when("/airline-carriers/:airCarriersId/info/loyalty-partnerships/:LoyaltyPartnershipItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirlineCarrierLoyaltyPartnershipsItem");
            },
          ],
        },
      })


      /**
       *************************** Airline Carriers END ***************************
       */

      /**
       *************************** Rail Suppliers START ***************************
       */

      .when("/rail-suppliers", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailSuppliersList");
            },
          ],
        },
      })

      .when("/rail-suppliers/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailSuppliersAddResource");
            },
          ],
        },
      })

      .when("/rail-suppliers/:railSupId", {
        redirectTo: "/rail-suppliers/:railSupId/info",
      })

      .when("/rail-suppliers/:railSupId/:railSupTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailSuppliersResource");
            },
          ],
        },
      })

      .when(
        "/rail-suppliers/:railSupId/info/fare-classes/:railSupFareClassItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("RailSupplierFareClassesGridItem");
              },
            ],
          },
        }
      )

      .when(
        "/rail-suppliers/:railSupId/info/fare-brand-name-mappings/:railSupFareBrandNameMapping",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("RailSupplierFareBrandNameMappingsGridItem");
              },
            ],
          },
        }
      )

      /**
       *************************** Rail Suppliers END ***************************
       */

      /**
       *************************** Car Suppliers START ***************************
       */

      .when("/car-suppliers", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersList");
            },
          ],
        },
      })

      .when("/car-suppliers/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersAddResource");
            },
          ],
        },
      })

      .when("/car-suppliers/:carSupId", {
        redirectTo: "/car-suppliers/:carSupId/info",
      })

      .when("/car-suppliers/:carSupId/:carSupTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersResource");
            },
          ],
        },
      })

      .when("/car-suppliers/:carSupId/:carSupTab/vehicles/:CarSupVhItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersVehiclesGridItem");
            },
          ],
        },
      })

      .when("/car-suppliers/:carSupId/:carSupTab/locations/:CarSupLocItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersLocationsGridItem");
            },
          ],
        },
      })

      /**
       *************************** Car Suppliers END ***************************
       */

      /**
       *************************** Hotels START ***************************
       */

      .when("/hotels", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelsList");
            },
          ],
        },
      })

      .when("/hotels/edit/:hotelId", {
        template: `<lba-edit-hotel></lba-edit-hotel>`,
      })

      /**
       *************************** Hotels END ***************************
       */

      /**
       *************************** POI START ***************************
       */

      .when("/points-of-interest", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PointsOfInterestList");
            },
          ],
        },
      })

      /**
       *************************** POI END ***************************
       */

      /**
       *************************** airports START ***************************
       */

      .when("/airports", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirportsList");
            },
          ],
        },
      })

      // TODO: Remove when testing its finished
      .when("/paging/airports", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PagingAirportsList");
            },
          ],
        },
      })

      // TODO: Remove both when entire feature its finished      
      .when("/paging/airports/add", { redirectTo: "/airports/add" })
      .when("/paging/airports/:airportId", {redirectTo: "/airports/:airportId/info"})

      .when("/airports/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirportsAddResource");
            },
          ],
        },
      })

      .when("/airports/:airportId", { redirectTo: "/airports/:airportId/info" })

      .when("/airports/:airportId/:airportTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirportsResource");
            },
          ],
        },
      })

      .when(
        "/airports/:airportId/info/fixed-base-operators/:AirportFixedBaseOperatorsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("AirportFixedBaseOperatorsItem");
              },
            ],
          },
        }
      )

      /**
       *************************** airports END ***************************
       */

      /**
       *************************** rail stations START ***************************
       */

      .when("/rail-stations", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailStationsList");
            },
          ],
        },
      })

      .when("/rail-stations/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailStationsAddResource");
            },
          ],
        },
      })

      .when("/rail-stations/:railStationId", {
        redirectTo: "/rail-stations/:railStationId/info",
      })

      .when("/rail-stations/:railStationId/:railStationTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailStationsResource");
            },
          ],
        },
      })

      .when("/rail-stations/:railStationId/info/suppliers/:railStationSup", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailStationsSuppliersItem");
            },
          ],
        },
      })

      /**
       *************************** rail stations END ***************************
       */

      /**
       *************************** rail cards START ***************************
       */

      .when("/rail-cards", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailCardsList");
            },
          ],
        },
      })

      .when("/rail-cards/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailCardsAddResource");
            },
          ],
        },
      })

      .when("/rail-cards/:railCardId", {
        redirectTo: "/rail-cards/:railCardId/info",
      })

      .when("/rail-cards/:railCardId/:railCardTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RailCardsResource");
            },
          ],
        },
      })

      .when("/rail-cards/:railCardId/info/accepted-suppliers/:railCardSup", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AcceptedSuppliersItem");
            },
          ],
        },
      })

      /**
       *************************** rail cards END ***************************
       */

      /**
       *************************** car supplier locations START ***************************
       */

      .when("/car-supplier-locations", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersLocations");
            },
          ],
        },
      })

      .when("/car-supplier-locations/:CarSupLocItem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarSuppliersLocationsGridItem");
            },
          ],
        },
      })

      //carSupId

      /**
       *************************** hotel suppliers START ***************************
       */

      .when("/hotel-supplier-membership-programs", {
        redirectTo:
          "/hotel-supplier-membership-programs/hotel-suppliers-listing",
      })

      .when("/hotel-supplier-membership-programs/:tab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelSuppliersResource");
            },
          ],
        },
      })

      .when("/hotel-supplier-membership-programs/hotel-suppliers-listing/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelSupplierMembershipProgramsAddResource");
            },
          ],
        },
      })

      .when(
        "/hotel-supplier-membership-programs/hotel-suppliers-listing/:hotelSupId",
        {
          redirectTo:
            "/hotel-supplier-membership-programs/hotel-suppliers-listing/:hotelSupId/info",
        }
      )

      .when(
        "/hotel-supplier-membership-programs/hotel-suppliers-listing/:hotelSupId/:hotelSupTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("HotelSupplierMembershipProgramsResource");
              },
            ],
          },
        }
      )

      .when("/hotel-supplier-membership-programs/master-chains-index/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("HotelMasterChainsAddResource");
            },
          ],
        },
      })

      .when(
        "/hotel-supplier-membership-programs/master-chains-index/:hotelSupId",
        {
          redirectTo:
            "/hotel-supplier-membership-programs/master-chains-index/:hotelSupId/info",
        }
      )

      .when(
        "/hotel-supplier-membership-programs/master-chains-index/:hotelSupId/:hotelSupTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("HotelMasterChainsResource");
              },
            ],
          },
        }
      )

      /**
       *************************** hotel suppliers END ***************************
       */

      /**
       *************************** micro-debtor START ***************************
       */

      .when("/ctm-debtors", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CtmDebtorsList");
            },
          ],
        },
      })

      .when("/ctm-debtors/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CtmDebtorsAddResource");
            },
          ],
        },
      })

      .when("/ctm-debtors/:ctmDebtorId", {
        redirectTo: "/ctm-debtors/:ctmDebtorId/info",
      })

      .when("/ctm-debtors/:ctmDebtorId/:ctmDebtorTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CtmDebtorsResource");
            },
          ],
        },
      })

      /**
       *************************** micro-debtor END ***************************
       */

      /**
       *************************** AppInsight Logs START ***************************
       */

      .when("/logs", { redirectTo: "/logs/appinsights-logs" })

      .when("/logs/:tab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("LogResource");
            },
          ],
        },
      })
      

      /**
       *************************** AppInsight Logs END ***************************
       */

             /**
       *************************** Enhanced Logs START ***************************
       */

      .when("/enhanced-logs", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("EnhancedLogResource");
            },
          ],
        },
      })
      

      

      /**
       *************************** Enhanced Logs END ***************************
       */

      /**
       *************************** Fly America Act START ***************************
       */

      .when("/fly-america/city-pair-program", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ProgramRouteResource");
            },
          ],
        },
      })

      .when("/fly-america/fly-america-config/Config/city-pair-program", {
        redirectTo: "/fly-america/city-pair-program",
      })

      .when("/fly-america/fly-america-config/Config/open-skies", {
        redirectTo: "/fly-america/open-skies",
      })

      .when("/fly-america/fly-america-config/:id/info", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CarriersResource");
            },
          ],
        },
      })

      .when(
        "/fly-america/fly-america-config/:id/info/open-skies/:OpenSkiesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("OpenSkiesItemResource");
              },
            ],
          },
        }
      )

      //default-fly-america-policy-exceptions
      .when(
        "/fly-america/fly-america-config/Config/default-fly-america-policy-exceptions",
        { redirectTo: "/fly-america/default-fly-america-policy-exceptions" }
      )

      .when(
        "/fly-america/fly-america-config/:id/info/default-fly-america-policy-exceptions/:DefaultFlyAmericaPolicyExceptionsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "DefaultFlyAmericaPolicyExceptionsItemResource"
                );
              },
            ],
          },
        }
      )

      .when("/fly-america/city-pair-program/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ProgramRouteAddResource");
            },
          ],
        },
      })

      .when("/fly-america/city-pair-program/add/info", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ProgramRouteAddResource");
            },
          ],
        },
      })

      .when("/fly-america/city-pair-program/:id", {
        redirectTo: "/fly-america/city-pair-program/:id/info",
      })

      .when("/fly-america/city-pair-program/:id/info", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ProgramRouteItemResource");
            },
          ],
        },
      })

      .when(
        "/fly-america/city-pair-program/:flyAmericaId/info/city-pair-program/:FlyAmericaCityPairItem",
        {
          redirectTo:
            "/fly-america/city-pair-program/:flyAmericaId/info/city-pair-program/:FlyAmericaCityPairItem/info",
        }
      )

      .when(
        "/fly-america/city-pair-program/:flyAmericaId/info/city-pair-program/:FlyAmericaCityPairItem/info",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CityPairProgramItem");
              },
            ],
          },
        }
      )

      .when("/fly-america", {
        redirectTo: "/fly-america/fly-america-config/Config/info",
      })

      /**
       *************************** Fly America Act END ***************************
       */

      /**
       *************************** Company Reference List Start ***************************
       */

      .when("/company-reference-list", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferenceManager");
            },
          ],
        },
      })

      .when("/company-references", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferenceList");
            },
          ],
        },
      })
      .when("/company-references/grid", { redirectTo: "/company-references" })

      .when("/company-references/grid/:debtorId/:listId", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferenceListFilter");
            },
          ],
        },
      })

      .when("/company-references/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferencesAddResource");
            },
          ],
        },
      })
      .when("/company-references/grid/:debtorId/:listId/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferencesAddResource");
            },
          ],
        },
      })

      .when("/company-references/:itemId", {
        redirectTo: "/company-references/:itemId/info",
      })

      .when("/company-references/:itemId/:companyReferencesTab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferencesResource");
            },
          ],
        },
      })
      .when("/company-references/grid/:debtorId/:listId/:itemId", {
        redirectTo: "/company-references/grid/:debtorId/:listId/:itemId/info",
      })

      .when(
        "/company-references/grid/:debtorId/:listId/:itemId/:companyReferencesTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CompanyReferencesResource");
              },
            ],
          },
        }
      )

      /**
       *************************** Company Reference List END ***************************
       */
      /**
       *************************** Company Reference Config Start ***************************
       */

      .when("/company-reference-config", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferenceConfig");
            },
          ],
        },
      })

      .when("/company-reference-config/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CompanyReferenceConfigAddResource");
            },
          ],
        },
      })

      .when("/company-reference-config/:companyReferenceConfigId", {
        redirectTo: "/company-reference-config/:companyReferenceConfigId/info",
      })

      .when(
        "/company-reference-config/:companyReferenceConfigId/:companyReferenceConfigTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CompanyReferenceConfigEditResource");
              },
            ],
          },
        }
      )

      .when(
        "/company-reference-config/:companyReferenceConfigId/:companyReferenceConfigTab/file-processing-logs/:logIndex",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CompanyReferenceConfigEditResourceViewLog");
              },
            ],
          },
        }
      )

      /**
       *************************** Company Reference Config END ***************************
       */
      /**
       *************************** Per Diem START ***************************
       */

      .when("/per-diem", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PerDiemManager");
            },
          ],
        },
      })

      .when("/per-diem/data", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PerDiemGridItem");
            },
          ],
        },
      })

      .when("/per-diem/file-upload", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("PerDiemFileUploader");
            },
          ],
        },
      })

      /**
       *************************** Per Diem END ***************************
       */
      /*************************** Enhanced Policy Rules START ***************************
       */

      .when("/enhanced-policy-rules", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("EnhancedPolicyRules");
            },
          ],
        },
      })

      .when("/enhanced-policy-rules/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("EnhancedPolicyRulesAddResource");
            },
          ],
        },
      })

      .when("/enhanced-policy-rules/:enhancedPolicyRulesId", {
        redirectTo: "/enhanced-policy-rules/:enhancedPolicyRulesId/info",
      })

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/display-message/",
        { redirectTo: "/enhanced-policy-rules/:enhancedPolicyRulesId/info" }
      )
      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-message/",
        { redirectTo: "/enhanced-policy-rules/:enhancedPolicyRulesId/info" }
      )
      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy/",
        { redirectTo: "/enhanced-policy-rules/:enhancedPolicyRulesId/info" }
      )
      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/force-credit-card/",
        { redirectTo: "/enhanced-policy-rules/:enhancedPolicyRulesId/info" }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/:enhancedPolicyRulesTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesEditResource");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/:EnhancedPolicyRulesNewActionsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesNewActionsItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/display-message/:EnhancedPolicyRulesActionsDisplayMessageItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsDisplayMessageItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/message-popup/:EnhancedPolicyRulesActionsDisplayMessageItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsMessagePopupItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-message/:EnhancedPolicyRulesActionsDisplayMessageItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsPolicyMessageItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/set-out-of-policy/:EnhancedPolicyRulesActionsDisplayMessageItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsSetOutOfPolicyItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy/:EnhancedPolicyRulesActionsDisplayMessageItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsPolicyItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/force-credit-card/:EnhancedPolicyRulesActionsForceCreditCardItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsForceCreditCardItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/force-credit-card/:EnhancedPolicyRulesActionsForceCreditCardItem/credit-card-matching/:CreditCardMatching",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsForceCreditCardCreditCardMatchingItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-remarks/:EnhancedPolicyRulesActionsPnrRemarksItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsPnrRemarksItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-remarks/:EnhancedPolicyRulesActionsPnrRemarksItem/gds-remarks/:EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesActionsPnrRemarksGdsRemarksItem");
              },
            ],
          },
        }
      )
      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-extra-action/:EnhancedPolicyRulesActionsPnrExtraActionItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsPnrExtraActionItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-extra-action/:EnhancedPolicyRulesActionsPnrExtraActionItem/profile-moves/:EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesActionsPnrExtraActionProfileMovesItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/pnr-extra-action/:EnhancedPolicyRulesActionsPnrExtraActionItem/queue-placements/:EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesActionsPnrExtraActionQueuePlacementsItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-settings/:EnhancedPolicyRulesActionsPolicySettingsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsPolicySettingsItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-settings/:EnhancedPolicyRulesActionsPolicySettingsItem/flight-modification-settings/:iiflightModificationSettingItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyFlightModificationSettingItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/policy-settings/:EnhancedPolicyRulesActionsPolicySettingsItem/flight-search-configuration/:iflightSearchConfigurationItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyFlightSearchConfigurationItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/conditions/:EnhancedPolicyRulesConditionsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesConditionsItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/debtors/:EnhancedPolicyRulesDebtorsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesDebtorsItem");
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/limit-passenger-policy/:EnhancedPolicyRulesActionsLimitPassengerItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget(
                  "EnhancedPolicyRulesActionsLimitPassengerItem"
                );
              },
            ],
          },
        }
      )

      .when(
        "/enhanced-policy-rules/:enhancedPolicyRulesId/info/actions/limit-passenger-policy/:EnhancedPolicyRulesActionsLimitPassengerItem/udid-configurations/:EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("EnhancedPolicyRulesLimitPassengerPolicyUdidConfigurationsItem");
              },
            ],
          },
        }
      )

      /**
       *************************** Enhanced Policy Rules END ***************************
       */

       /*************************** Process Upload Status START ***************************
       */

       .when("/process-upload-status", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("ProcessUploadStatus");
            },
          ],
        },
      })

      .when("/process-upload-status/:processUploadStatusId", {
        redirectTo: "/process-upload-status/:processUploadStatusId/info",
      })

      .when(
        "/process-upload-status/:processUploadStatusId/:processUploadStatusTab",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("ProcessUploadStatusViewResource");
              },
            ],
          },
        }
      )

      /**
       *************************** Process Upload Status END ***************************
       */

      /*************************** Manage SAF Scores START ****************************/

      .when("/saf-scores", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SafScoresList");
            },
          ],
        },
      })

      .when("/saf-scores/:safScoresId", { redirectTo: "/saf-scores/:safScoresId/info" })

      .when("/saf-scores/:safScoresId", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("SafScoresResource");
            },
          ],
        },
      })

      /***************************** Manage SAF Scores END ****************************/

      /**
       *************************** Vendor Preference Config START ***************************
       */

      .when("/vendor-preference-configs", { redirectTo: "/vendor-preference-configs/campaigns" })

      .when("/vendor-preference-configs/:tab", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("VendorPreferenceConfigs");
            },
          ],
        },
      })

      .when("/vendor-preference-configs/rules/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("RulesGridItemAddResource");
            },
          ],
        },
      })

      .when(
        "/vendor-preference-configs/rules/:rRulesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("RulesGridItem");
              },
            ],
          },
        }
      )
       .when("/vendor-preference-configs/rules/flight/:rRulesItem/routing-pairs/:rtPairItemId", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("AirPrefRtPairItem");
            },
          ],
        },
      })
      .when(
        "/vendor-preference-configs/rules/flight/:rRulesItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("RulesGridFlightItem");
              },
            ],
          },
        }
      )

      .when("/vendor-preference-configs/campaigns/add", {
        template: rootRouteTemplate,
        controller: ["targetName", rootRouteController],
        controllerAs: "vm",
        resolve: {
          targetName: [
            () => {
              return injectTarget("CampaignsGridItemAddResource");
            },
          ],
        },
      })

      .when(
        "/vendor-preference-configs/campaigns/:cCampaignsItem",
        {
          template: rootRouteTemplate,
          controller: ["targetName", rootRouteController],
          controllerAs: "vm",
          resolve: {
            targetName: [
              () => {
                return injectTarget("CampaignsGridItem");
              },
            ],
          },
        }
      )

      /**
       *************************** Vendor Preference Config END ***************************
       */

      .otherwise({
        template: redirectTemplate,
        controller: [rootRouteController],
        controllerAs: "vm",
      });
  };

  RouterConfig.$inject = $inject;

  return RouterConfig;
};



// WEBPACK FOOTER //
// ./src/config/routerConfig.js